// TableRowComponent.tsx
import { TableCell, TableRow } from '@mui/material'
import moment from 'moment'
import { NotifyGateway } from '../../../components/GroupsTable/types'

interface TableRowNotificationComponentProps {
  row: NotifyGateway
}

export default function TableRowNotificationComponent({ row }: TableRowNotificationComponentProps) {
  const timeDate = row.stats_last_seen
    ? moment.utc(row.stats_last_seen).local().format(`${process.env.REACT_APP_DATE_FORMAT} h:mm A`)
    : '-'

  return (
    <TableRow hover role='checkbox' tabIndex={-1}>
      <TableCell>{row.gw_uid}</TableCell>
      <TableCell>{timeDate || '-'}</TableCell>
    </TableRow>
  )
}
